//services/UserApi.js
import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

// Report issue
export const reportIssue = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/report-issue`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data.error);
  }
};

//get people
export const getPeople = async (query) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/people?give_me=${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get hashtags Get all hashtags
export const getHashtags = async (query) => {
  console.log("getHashtags", query);
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/hashtags?give_me=${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("getHashtags", response.data.data);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const fetchPeopleWithoutLogin = async () => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/people`,
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get people you may know /api/v1/user/new-account-pops/people-you-may-know
export const getPeopleYouMayKnow = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/new-account-pops/people-you-may-know`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get conectios list by username , types  can be "connections", "following',
export const getConnections = async (username,  page, searchText, user_connection_type) => {
  const token = getToken();
  try {
    // Build query params properly, only include if they have valid values
    const params = new URLSearchParams();
    if (searchText && searchText.length >= 3) {
      params.append('search', searchText);
    }
    if (page && page > 0) {
      params.append('page', page);
    }
    if (user_connection_type) {
      params.append('type', user_connection_type);
    }

    const queryString = params.toString();
    const url = `${apiurl}/api/v1/user/connection/list/${username}${queryString ? '?' + queryString : ''}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// follow the organization 
export const followOrganization = async (userId) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/connection/follow-organizations/${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("followOrganization", response.data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const createChatId = async (userId) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/chats/create-chat-id/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


//send connection request
export const sendConnectionRequest = async (userId) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/connection/request/${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// cancel connection request
export const cancelConnectionRequest = async (userId) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/connection/remove/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//accept connection request
export const acceptConnectionRequest = async (requesterId) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/connection/accept/${requesterId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//decline connection request
export const declineConnectionRequest = async (requesterId) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/connection/decline/${requesterId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getUser = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const checkUserName = async (username) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/about/user-name-available`,
      { username },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get user profile by username
export const getUserProfileByUsername = async (username) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/profile-detail-data/${username}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get user post by username
export const getUserPostsByUsername = async (username, page) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user-posts/${username}?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const updateProfileImage = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/about/update-photo`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const profileDetails = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/profile/detail`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("profileDetails", response.data);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getAnswer = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/profile/about/why-im-here`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const getUserProfileDetails = async (query) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/detail?query=${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateProfile = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/about/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getLanguagesList = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/language/list`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateLanguages = async (data) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/language/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getLocationsList = async (city) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/location/list/${city}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get country list /api/v1/user/profile/location/countries
export const getCountryList = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/location/countries`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get cities by country  /api/v1/user/profile/location/countries/{country}/cities
export const getCitiesByCountry = async (country) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/location/countries/${country}/cities`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// add or update location  /api/v1/user/profile/location/cities
export const addOrUpdateLocation = async (location_ids) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/location/cities`,
      { location_ids },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const updateAddress = async (data) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/address`,
      {address: data},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// add or update interests /api/v1/user/profile/interests
export const addOrUpdateInterests = async (interests) => {
  const token = getToken();

  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/interests`,
      { interests },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// add custom interest /api/v1/user/profile/interests/custom
export const addCustomInterest = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/interests/custom`, data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error);
  }
};


export const updatePostPrivacy = async (data) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/privacy/switch-post-type`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const getIndustryList = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/organization-industries`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const getOrganizationTypes = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/organization-types`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const getSkillsList = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/skill/list`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateSkills = async (data) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/skill/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


// custom skills
export const addCustomSkill = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/skill/add-other`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteCustomSkill = async (id) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/profile/skill/delete-other/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};








export const getRoleList = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/experience/roles`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateExperience = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/experience/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteExperience = async (id) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/profile/experience/delete/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getSocialLinks = async () => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/profile/social/list`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateSocialLinks = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/social-media/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteSocialLink = async (id) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/profile/social-media/delete/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// report user
export const reportUser = async (userId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/${userId}/report`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//block user
export const blockUser = async (userId) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/${userId}/block`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("blockUser response", response);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


// Education section start  
export const addEducation = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/education`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// delete education
export const deleteEducation = async (id) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/profile/education/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// update education
export const updateEducation = async (data, id) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/education/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//delete account request
export const deleteAccountRequest = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/account-settings/delete-request`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const nudgeUser = async () => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/nudge`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
}

export const getAccountDescription = async (account_type) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/account-description?account_type=${account_type}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}

export const addOrganizationService = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/organization-services`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteOrganizationService = async (organization_service_map_id) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/profile/organization-services/${organization_service_map_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const updateOrganizationService = async (organization_service_map_id, data) => {
  const token = getToken();
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/profile/organization-services/${organization_service_map_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const addOrganizationPortfolio = async (payload) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/organization-portfolios`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


export const updateOrganizationPortfolio = async (editId, payload) => {
  const token = getToken();
  try {
    const response = await axios.post(
      `${apiurl}/api/v1/user/profile/organization-portfolios/${editId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const deleteOrganizationPortfolio = async (deletingId) => {
  const token = getToken();
  try {
    const response = await axios.delete(
      `${apiurl}/api/v1/user/profile/organization-portfolios/${deletingId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getOrgHighlights = async (username) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/org-highlights/${username}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const getOrgServices = async (username) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/org-services/${username}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//Organization-portfolios
export const getOrganizationPortfolios = async (username, page) => {
  const token = getToken();
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/org-portfolios/${username}?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};